const craftsman_task = {
	name: 'Craftsman Task | Craftsman Tasks',
	icon: 'fas fa-hammer',
	fields: {
		hp_id: 'ID',
		building: {
			name: '@:entity.building.name',
		},
		first_unit: {
			position: '@:entity.unit.fields.position',
		},
		to_occur: '@:common.toOccur',
		subject_type: 'Type',
		subject: '@:common.subject',
		status: {
			name: 'Status',
		},
	},
}

export default craftsman_task
